import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface Props { to: string; label: string; }
export function DrillLink({ to, label }: Props) {
  return (
    <Link to={to} className="inline-flex items-center gap-1 text-sm font-medium text-[var(--text-ter)] hover:text-[var(--text-ter)] transition-colors">
      {label}<ChevronRight className="h-3.5 w-3.5" />
    </Link>
  );
}
